// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import MatchProvisionStatus from "./match_provision_status_type";
import GameMode from "./game_mode_type";
import Difficulty from "./difficulty_type";
import TacticsBoardPreset from "./tactics_board_preset_type";


export default __t.object("ActiveMatchDirectory", {
  matchId: __t.u64(),
  regionId: __t.string(),
  regionUrl: __t.string(),
  get status() {
    return MatchProvisionStatus;
  },
  get mode() {
    return GameMode;
  },
  get difficulty() {
    return Difficulty;
  },
  width: __t.u8(),
  height: __t.u8(),
  minesCount: __t.u16(),
  playerUserIds: __t.array(__t.u64()),
  playerUsernames: __t.array(__t.string()),
  hostUserId: __t.u64(),
  maxPlayers: __t.u8(),
  isPrivate: __t.bool(),
  matchCode: __t.option(__t.string()),
  createdAt: __t.u64(),
  startedAt: __t.option(__t.u64()),
  completedAt: __t.option(__t.u64()),
  shieldsPerPlayer: __t.u8(),
  penaltyPerShieldMs: __t.u32(),
  finishWindowMs: __t.u32(),
  finishWindowStrict: __t.bool(),
  chordingEnabled: __t.bool(),
  spectatorUserIds: __t.array(__t.u64()),
  ttMaxRevealsPerTurn: __t.u8(),
  ttTimeInitialMs: __t.u64(),
  ttTimeIncrementMs: __t.u64(),
  get ttBoardPreset() {
    return __t.option(TacticsBoardPreset);
  },
  hostOnlyReset: __t.bool(),
  isRankedQueue: __t.bool(),
});


